<template>
  <div
    ref="sectionRef"
    class="flex flex-1 flex-col h-full items-center relative"
    style="justify-content: center"
  >
    <div class="page-mx module-my relative z-1" v-if="blok?.texts?.length">
      <span
        class="absolute left-50% top-0 z--1 translate-x-[-50%] m-auto text-headline-lg clamp-text-40-200 clamp-leading-40-200 color-black opacity-30% pointer-events-none"
        :style="{
          'font-weight': `var(--fw-display-md)`,
        }"
        >404</span
      >
      <div class="flex items-center justify-center w-full">
        <ElementMedia
          v-if="blok.graphic?.length"
          :bloks="blok.graphic"
          :ratio="{ w: 1, h: 1 }"
          :sizes="[
            { bpMin: '0', vw: 50 },
            { bpMin: 'tp', vw: 30 },
          ]"
          loading="eager"
          class="clamp-w-50-100 h-full object-cover aspect-1"
        />
      </div>
      <ElementTexts
        v-if="blok.texts.length"
        :bloks="blok.texts"
        textPosition="center"
      />
    </div>
    <div class="page-mx module-my" v-else>
      <!-- in the editor in root or folder without a build config -->
      <div class="element-texts-my mx-auto justify-center text-center">
        <h2 class="font-bold clamp-mb-4-8">Page not found</h2>
        <p>Please go into a brand folders and select a page from there:</p>
        <div class="clamp-mt-2-4">
          <p v-for="brand in brandKeysReversed">
            <a :href="`/${brand}`" class="underline color-[#0000EE]"
              >/{{ brand }}</a
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import useConfig from '@/composables/useConfig';
import { ISbPluginThemeColorPicker } from '@/types';
import useSectionTheme from '@/composables/useSectionTheme';
import brandsJson from '@/auto-generated/brands.json';

const brandKeysReversed = Object.keys(brandsJson).reverse();

const { config, brand } = useConfig();
const blok = computed(() => config.value?.errorPageNotFound[0]);

const sectionRef = ref<HTMLElement | null>(null);
const { observeThemeSection } = useSectionTheme();

const theme = computed(() => {
  const colors = blok.value?.backgroundColor as ISbPluginThemeColorPicker;
  return {
    bg: colors?.hex,
    text: colors?.hexFg,
  };
});

observeThemeSection(sectionRef, theme);
</script>
<style scoped lang="scss"></style>
